/**
 * Section Templates
 * Defines preset layouts for sections with columns
 */

export interface SectionTemplate {
  id: string;
  displayName: string;
  description: string;
  columnCount: number;
  columnWidths?: string[]; // Optional custom widths
}

export const SECTION_TEMPLATES: SectionTemplate[] = [
  {
    id: 'section-2col',
    displayName: '2 Columns',
    description: 'Section with 2 equal columns',
    columnCount: 2,
  },
  {
    id: 'section-3col',
    displayName: '3 Columns',
    description: 'Section with 3 equal columns',
    columnCount: 3,
  },
  {
    id: 'section-4col',
    displayName: '4 Columns',
    description: 'Section with 4 equal columns',
    columnCount: 4,
  },
];

/**
 * Check if a block type is a section template
 */
export function isSectionTemplate(blockType: string): boolean {
  return SECTION_TEMPLATES.some(template => template.id === blockType);
}

/**
 * Get section template by ID
 */
export function getSectionTemplate(templateId: string): SectionTemplate | undefined {
  return SECTION_TEMPLATES.find(template => template.id === templateId);
}

/**
 * Get column width for a template
 */
export function getColumnWidth(template: SectionTemplate, columnIndex: number): string {
  if (template.columnWidths && template.columnWidths[columnIndex]) {
    return template.columnWidths[columnIndex];
  }
  
  // Equal width distribution
  const percentage = Math.floor(100 / template.columnCount);
  return `${percentage}%`;
}
